import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { VhIconComponent } from '../icon/icon.component';

export interface VhSortOption {
  value: string;
  label: string;
}

/**
 * Labeled native select for sort order. Native picker gets mobile UX for
 * free and needs zero extra deps — the Material version can replace
 * this later if designer wants a richer menu.
 */
@Component({
  selector: 'vh-sort-select',
  standalone: true,
  imports: [VhIconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <label class="vh-sort-select">
      <span class="vh-sort-select__label">{{ label() }}</span>
      <span class="vh-sort-select__control">
        <select [value]="value()" (change)="onChange($event)" [attr.aria-label]="label()">
          @for (opt of options(); track opt.value) {
            <option [value]="opt.value">{{ opt.label }}</option>
          }
        </select>
        <vh-icon class="vh-sort-select__chev" name="chevron-down" size="sm" />
      </span>
    </label>
  `,
  styleUrl: './sort-select.component.scss',
})
export class VhSortSelectComponent {
  readonly options = input.required<ReadonlyArray<VhSortOption>>();
  readonly value = input<string>('');
  readonly label = input<string>('Sort by');

  readonly valueChange = output<string>();

  onChange(event: Event): void {
    this.valueChange.emit((event.target as HTMLSelectElement).value);
  }
}
